<fs-sidenav [config]="sideNavConfig"></fs-sidenav>